import Config from '../components/graphql/GraphQL.config';
import ApolloClient from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';

import { addFiles } from '../graphQL/mutations/shipmentMutations';
import { getGlobalProps } from './queryHelpers';
import { allowedFileTypes } from '../constants/constants';

import { XHRUpload } from 'uppy';

import _invert from 'lodash/invert';

const { Plugin } = require('@uppy/core');

class PropelFileUploader extends Plugin {
  constructor(uppy, opts) {
    super(uppy, opts);
    this.uppy = uppy;
    this.id = 'PropelFileUploader';
    this.type = 'uploader';
    this.upload = this.upload.bind(this);
    this.input = opts.input;
    this.endpoint = opts.endpoint;
    this.method = opts.method;
    this.headers = opts.headers;
    this.params = opts.params;

    const link = new Config().getConfig();
    this.graphqlClient = new ApolloClient({
      clientState: {},
      link,
      cache: new InMemoryCache()
    });
  }

  async upload(fileIDs) {
    function delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }

    for (const fileID of fileIDs) {
      const file = this.uppy.getFile(fileID);
      if (file.response) continue;

      // simulate progress
      for (let sent = 0; sent < file.size;) {
        sent = Math.min(file.size, sent + Math.floor(Math.random() * 0.5 * file.size));
        this.uppy.emit('upload-progress', file, {
          uploader: this,
          bytesUploaded: sent,
          bytesTotal: file.size,
        });
        await delay(150);
      }

      this.uppy.emit('upload-success', file, {
        status: 201,
        body: '',
        uploadUrl: '/files',
      })
    }


    // const { orgId } = getGlobalProps().orgInfo;

    // const xhrUploader = new XHRUpload(this.uppy, {
    //   endpoint: this.endpoint,
    //   method: this.method,
    //   headers: this.headers,
    //   getResponseData: () => JSON.parse('{}')
    // });

    // const promises = [];

    // await Promise.all(
    //   fileIDs.map(async fileID => {
    //     if (this.uppy.getFile(fileID).response) {
    //       return false;
    //     }

        // const file = this.uppy.getFile(fileID).data;
        // try {
        //   const {
        //     data: {
        //       shipment: { addFiles: filesToUpload }
        //     }
        //   } = await this.graphqlClient.mutate({
        //     mutation: addFiles,
        //     variables: {
        //       files: [
        //         {
        //           orgId,
        //           fileName: file.name,
        //           fileTypeId: allowedFileTypes[file.type],
        //           ...this.params
        //         }
        //       ]
        //     }
        //   });

          // this.uppy.setFileMeta(fileID, { id: filesToUpload[0].id });

    //       return promises.push(
    //         xhrUploader.upload(this.uppy.getFile(fileID), 1, 10)
    //       );
    //     } catch (error) {
    //       return console.error(error);
    //     }
    //   })
    // );

    // return Promise.all(promises);
  }

  install() {
    this.uppy.addUploader(this.upload);
  }

  uninstall() {
    this.uppy.removeUploader(this.upload);
  }
}

export const getFileUrl = async (fileURL, type) => {
  const response = await fetch(fileURL);
  const blob = await response.blob();
  const file = new Blob([blob], { type: _invert(allowedFileTypes)[type] });
  return URL.createObjectURL(file);
};

export default PropelFileUploader;
